import React from "react";
import App from './App';

import { useAutoUserTracking } from "../../hooks/useTracking";

const AppWrapper = (props) => {
  useAutoUserTracking();
  return <App {...props} />;
};

export default AppWrapper ;